import * as React from "react";
import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children, requireAdmin = false }: { children: React.ReactNode; requireAdmin?: boolean }) => {
    const { user } = useAuth();

    if (!user) return <Navigate to="/login" />;
    if (requireAdmin && !user.isAdmin) return <Navigate to="/reports" />;

    return <>{children}</>;
};

export const RootRedirect = () => {
    const { user } = useAuth();
    if (!user) return <Navigate to="/login" />;
    return user.isAdmin ? <Navigate to="/admin" replace /> : <Navigate to="/reports" replace />;
};
